import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-uig-campaign-note',
    templateUrl: './uig-campaign-note.component.html',
    styleUrls: ['./uig-campaign-note.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigCampaignNoteComponent {
  @Input() public product?: Product;

  product$: Observable<Product> = this.currentProductService.getProduct();
  
  constructor(private currentProductService: CurrentProductService) { }

}
